// export const getPolylineStringFromCoordinates = async (
//     coordinates: { latitude: number; longitude: number }[]
// ): Promise<string> => {
//     try {
//         if (!coordinates || coordinates.length < 2) return '';

//         const start: { latitude: number; longitude: number } = coordinates[0]!;
//         const end: { latitude: number; longitude: number } = coordinates[coordinates.length - 1]!;

//         // OSRM expects lon,lat order
//         const url = `http://172.105.98.102:5000/route/v1/driving/${start.longitude},${start.latitude};${end.longitude},${end.latitude}?overview=full&geometries=polyline6`;

//         const resp = await fetch(url);
//         if (!resp.ok) return '';

//         const data = await resp.json();
//         const geometry: unknown = (data as any)?.routes?.[0]?.geometry;
//         return typeof geometry === 'string' ? geometry : '';
//     } catch (err) {
//         console.error('getPolylineStringFromCoordinates error', err);
//         return '';
//     }
// };
export const getPolylineStringFromCoordinates = async (
  coordinates: { latitude: number; longitude: number }[]
): Promise<{ geometry: string; duration: unknown } | ''> => {
  try {
    if (!coordinates || coordinates.length < 2) return '';

    // Convert ALL coordinates to OSRM format (lon,lat)
    const coordinateString = coordinates
      .map(coord => `${coord.longitude},${coord.latitude}`)
      .join(';');

    const url = `https://osm.getzump.com/route/v1/driving/${coordinateString}?overview=full&geometries=polyline6`;

    const resp = await fetch(url);
    if (!resp.ok) return '';

    const data = await resp.json();

    const geometry: unknown = (data as any)?.routes?.[0]?.geometry;
    const duration: unknown = (data as any)?.routes?.[0]?.duration;

    return typeof geometry === 'string' ? { geometry, duration } : '';
  } catch (err) {
    console.error('getPolylineStringFromCoordinates error', err);
    return '';
  }
};

export const getDistance = (lat1: any, lon1: any, lat2: any, lon2: any) => {
  const R = 6371;
  const toRadians = (degree: any) => (degree * Math.PI) / 180;
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c * 1000;
}

